module.exports = __webpack_public_path__ + "img/zakharov.e9b82d06.png";